export default {"src":"/_next/static/media/dice_40.f103a1b3.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};